import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Location } from '@angular/common';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { LoginModel } from 'src/app/models/legacy';
import { UserProfileModel } from 'src/app/models/repository/user-profile.model';
import { ImageCropperPopupComponent } from 'src/app/popups/image-cropper-popup/image-cropper-popup.component';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { EventsEmitter } from 'src/app/shared/event-emitter/EventEmitter';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CountryISO, PhoneNumberFormat, SearchCountryField, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FormUtilsService } from 'src/app/services/formUtils.service';

@Component({
  selector: 'vet-profile',
  templateUrl: './vet-profile.component.html',
  styleUrls: ['./vet-profile.component.scss'],
})
export class VetProfileComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  public userProfileForm: FormGroup;

  public isLoader = false;
  public closeResult = '';
  public SearchCountryField = SearchCountryField;
  public CountryISO = CountryISO;
  public PhoneNumberFormat = PhoneNumberFormat;
  public preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Australia, CountryISO.NewZealand, CountryISO.SouthAfrica, CountryISO.France];

  public responseSuccess: any = null;
  public responseError: any = null;
  public logoImage: any = 'assets/images/no-image-placeholder.jpeg';
  public headerImage: any = 'assets/images/no-image.png';
  public submitted = false;
  private file: File;
  private headerFile: File;
  public user: LoginModel;
  public userProfleModel: UserProfileModel;
  @ViewChild('fileInput') el: ElementRef;
  @ViewChild('headerFileInput') elHeader: ElementRef;
  imageUrl: any = 'assets/images/user.png';

  @Input() public isUseBuiltInSave = true;

  public config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
      ],
      image: [
        ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
        ['float', ['floatLeft', 'floatRight', 'floatNone']],
        ['remove', ['removeMedia']]
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear'
          ]
        ]
      ]
    },
    height: '500px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['customButtons', ['testBtn']],
      ['view', ['fullscreen', 'codeview', 'help']]
    ],
    fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36', '44', '56', '64', '76', '84', '96'],
    fontNames: ['Arial', 'Times New Roman', 'Inter', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times', 'MangCau', 'BayBuomHep', 'BaiSau', 'BaiHoc', 'CoDien', 'BucThu', 'KeChuyen', 'MayChu', 'ThoiDai', 'ThuPhap-Ivy', 'ThuPhap-ThienAn'],

    codeviewFilter: true,
    codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true
  };
  countries: any[] = [];

  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly eventEmitter: EventsEmitter,
    private readonly location: Location,
    private toastService: ToastService,
    private readonly modalService: NgbModal,
    private commonService: CommonService,
    private formUtilsService: FormUtilsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLoader = true;
    this.loadUser();
    this.loadProfile();

    this.userProfileForm = this.formBuilder.group({
      gender: ['dr', [Validators.required]],
      headerImage: [''],
      logoImage: [''],

      enquiryEmailAddress: ['', [Validators.email]],
      organisation: ['', [Validators.required]],
      organisationID: [''],
      dicomDeviceId: [0],
      licenseNumber: [''],
      websiteUrl: [''],
      address: ['', [Validators.required]],
      stateName: ['', [Validators.required]],
      countryName: ['', [Validators.required]],
      postCode: ['', [Validators.required]],
      phoneNumber: [''],
      phoneNumberCountryCode: [''],
      phoneNumber2: [''],
      phoneNumber2CountryCode: [''],
      city: ['', [Validators.required]],
      contactNumber1: [''],
      contactNumber1CountryCode: [''],
      contactNumber2: [''],
      contactNumber2CountryCode: [''],
      phoneNumberControl: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },
      phoneNumber2Control: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },
      contactNumber1Control: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },
      contactNumber2Control: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },
      //selectedCountryISO: null,
      selectedPNCountryISO: null,
      selectedPN2CountryISO: null,
      selectedCN1CountryISO: null,
      selectedCN2CountryISO: null,

    });

    this.userProfileForm.get('phoneNumberControl')?.valueChanges.subscribe(value => {
      const processedNumber = value?.internationalNumber?.replace(value?.dialCode, '')?.trim() || '';
      this.userProfileForm.get('phoneNumber')?.patchValue(processedNumber);
      this.userProfileForm.get('phoneNumberCountryCode')?.patchValue(value?.dialCode);
    });


    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.countries = responseData;

          if (this.countries && this.countries?.length > 0) {
          }
        }
      }
    });
    setTimeout(() => {
      document.querySelectorAll("[data-toggle='dropdown']").forEach((el) => {
        el.setAttribute("data-bs-toggle", "dropdown");
      });
      document.querySelectorAll("[data-dismiss='modal']").forEach((el) => {
        el.setAttribute("data-bs-dismiss", "modal");
        el.setAttribute("class", "btn-close");
        el.textContent = ''
      });
      document.querySelectorAll(".modal-header").forEach((el) => {
        el.setAttribute("dir", "rtl");
      });
    }, 400)

  }

  // make sure to destory the editor
  override ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public loadUser(): void {
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
      }
    });
  }

  uploadFile(event: Event) {
    const modalRef = this.modalService.open(ImageCropperPopupComponent, {
      ariaLabelledBy: 'LogoImageCropperId',
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static',
    });

    const data = {
      file: event,
      from: 'imageFile',
      aspectRatio: 4 / 4,
      cropperMinWidth: 500,
      cropperMinHeight: 500,
      cropperMaxWidth: 500,
      cropperMaxHeight: 500,
      roundCropper: false,
      containWithinAspectRatio: false,
      maintainAspectRatio: true,
      format: 'png',
      alignImage: 'left',
    };

    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        const data = result;
        this.logoImage = data.croppedImageBase64;
        this.file = data.croppedImageFile;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  uploadHeaderFile(event: Event) {
    const modalRef = this.modalService.open(ImageCropperPopupComponent, {
      ariaLabelledBy: 'HeaderImageCropperId',
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static',
    });

    const data = {
      file: event,
      from: 'imageFile',
      aspectRatio: 3 / 1,
      cropperMinWidth: 620,
      cropperMinHeight: 250,
      cropperMaxWidth: 620,
      cropperMaxHeight: 250,
      roundCropper: false,
      containWithinAspectRatio: false,
      maintainAspectRatio: true,
      format: 'png',
      alignImage: 'left',
    };

    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        const data = result;
        this.headerImage = data.croppedImageBase64;
        this.headerFile = data.croppedImageFile;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public loadProfile(): void {
    if (this.user) {
      this.userService
        .getMemberProfile()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (response) => {
            if (response) {
              this.userProfleModel = response;
              if (this.userProfleModel.logoImage) {
                this.logoImage = this.userProfleModel.logoImage;
              }
              if (this.userProfleModel.headerImage) {
                this.headerImage = this.userProfleModel.headerImage;
              }
              const formData = {

                //title: this.userProfleModel?.title,
                enquiryEmailAddress: this.userProfleModel?.enquiryEmailAddress,

                organisation: this.userProfleModel?.organisation,
                organisationID: this.userProfleModel?.organisationID,
                dicomDeviceId: this.userProfleModel?.dicomDeviceId,
                licenseNumber: this.userProfleModel?.licenseNumber,
                logoImage: this.userProfleModel?.logoImage,
                headerImage: this.userProfleModel?.headerImage,
                websiteUrl: this.userProfleModel?.websiteUrl,
                address: this.userProfleModel?.address,
                stateName: this.userProfleModel?.stateName,
                countryName: this.userProfleModel?.countryName,
                postCode: this.userProfleModel?.postCode,
                phoneNumber: this.userProfleModel?.phoneNumber,
                phoneNumberCountryCode: this.userProfleModel?.phoneNumberCountryCode,
                phoneNumber2: this.userProfleModel?.phoneNumber2,
                phoneNumber2CountryCode: this.userProfleModel?.phoneNumber2CountryCode,
                suburb: this.userProfleModel?.suburb,
                city: this.userProfleModel?.city,
                contactNumber1: this.userProfleModel?.contactNumber1,
                contactNumber1CountryCode: this.userProfleModel?.contactNumber1CountryCode,
                contactNumber2: this.userProfleModel?.contactNumber2,
                contactNumber2CountryCode: this.userProfleModel?.contactNumber2CountryCode,
                emailSignature: this.userProfleModel?.emailSignature,
                
                selectedPNCountryISO: this.userProfleModel?.phoneNumber != null ? this.setDefaultCountryFromDialCode(this.userProfleModel?.phoneNumberCountryCode).trim() : null,
                phoneNumberControl: this.userProfleModel?.phoneNumber != null ? this.userProfleModel?.phoneNumber.replace(this.userProfleModel?.phoneNumberCountryCode, '').trim() : null,

                selectedPN2CountryISO: this.userProfleModel?.phoneNumber2 != null ? this.setDefaultCountryFromDialCode(this.userProfleModel?.phoneNumber2CountryCode).trim() : null,
                phoneNumber2Control: this.userProfleModel?.phoneNumber2 != null ? this.userProfleModel?.phoneNumber2.replace(this.userProfleModel?.phoneNumber2CountryCode, '').trim() : null,

                selectedCN1CountryISO: this.userProfleModel?.contactNumber1 != null ? this.setDefaultCountryFromDialCode(this.userProfleModel?.contactNumber1CountryCode).trim() : null,
                contactNumber1Control: this.userProfleModel?.contactNumber1 != null ? this.userProfleModel?.contactNumber1.replace(this.userProfleModel?.contactNumber1CountryCode, '').trim() : null,

                selectedCN2CountryISO: this.userProfleModel?.contactNumber2 != null ? this.setDefaultCountryFromDialCode(this.userProfleModel?.contactNumber2CountryCode).trim() : null,
                contactNumber2Control: this.userProfleModel?.contactNumber2 != null ? this.userProfleModel?.contactNumber2.replace(this.userProfleModel?.contactNumber2CountryCode, '').trim() : null,
                file: '',
              };
              this.userProfileForm.patchValue(formData);
            }

            this.isLoader = false;
          },
          (error) => {
            if (error.status === 401) {
              this.authService.logout();
              window.location.href = '/';
            }
          }
        );
    }
  }
  private setDefaultCountryFromDialCode(code: string): string {
    var countryCode = '';
    if (code) {
      const dialCode = code.replace('+', '');
      const matched = (window as any).intlTelInputGlobals.getCountryData().find((c: any) => c.dialCode === dialCode);

      if (matched) {
        countryCode = matched.iso2.toUpperCase() as CountryISO;
      }
    }
    return countryCode;
  }
  // Simple country code detection - expand as needed
  /*private getCountryCodeFromPhone(phoneNumber: string): string {
    const matchedCountry = typeof phoneNumber === 'undefined' || phoneNumber === '' ? '' : this.countries.find(country =>
      phoneNumber.startsWith(country.code));

    return matchedCountry?.code ?? ''; // Default
  }*/
private isNullOrUndefined(value: any): value is null | undefined | '' {
  return (value === '' || value === undefined) ? null : value;
}
  public formSubmit(): void {
    this.submitted = true;
    this.formUtilsService.MarkFormFieldsTouched(this.userProfileForm);
    if (this.userProfileForm.invalid) {
      return;
    }

    let formData = new FormData();
    const form = this.userProfileForm.value;

    form.phoneNumber = form.phoneNumberControl?.internationalNumber.replace(form.phoneNumberControl?.dialCode ?? form.phoneNumberCountryCode, '').trim();
    form.phoneNumber2 = this.isNullOrUndefined(form.phoneNumber2Control?.internationalNumber.replace(form.phoneNumber2Control?.dialCode ?? form.phoneNumber2CountryCode, '').trim());
    form.contactNumber1 = this.isNullOrUndefined(form.contactNumber1Control?.internationalNumber.replace(form.contactNumber1Control?.dialCode ?? form.contactNumber1CountryCode, '').trim());
    form.contactNumber2 = this.isNullOrUndefined(form.contactNumber2Control?.internationalNumber.replace(form.contactNumber2Control?.dialCode ?? form.contactNumber2CountryCode, '').trim());

    form.phoneNumberCountryCode = form.phoneNumberControl?.dialCode;
    form.phoneNumber2CountryCode = form.phoneNumber2Control?.dialCode;
    form.contactNumber1CountryCode = form.contactNumber1Control?.dialCode;
    form.contactNumber2CountryCode = form.contactNumber2Control?.dialCode;


    for (var key in form) {
      formData.append(key, form[key] === null ? '' : form[key]);
    }
    if (this.file) {
      formData.append('logoFile', this.file);
    }
    if (this.headerFile) {
      formData.append('headerFile', this.headerFile);
    }
    this.userService
      .postMemberProfile(formData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          this.eventEmitter.emitTopBannerEvent(response);

          if (response) {
            this.authService.setUserProfileStatus(response.hasBusinessProfile);
            if (response.image) {
              this.authService.setUserImage((response.image as string));
            }else {
              this.authService.setUserImage(("assets/images/user.png" as string));
            }


            this.toastService.success('Profile has been updated');
            this.location.back();
          }
        },
        (errorResponse: Error) => {
          this.submitted = false;
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (errorData?.status === 401 || errorData?.status === 500) {
              this.toastService.success(errorData.error.message);
            }

            if (errorData?.status === 400) {
              let errorMessages = '';
              if (errorData.error instanceof Array) {
                errorData.error.forEach((value: { message: string }) => {
                  errorMessages += value.message + '\n';
                });
              } else {
                errorMessages = errorData.error.message;
              }
              this.toastService.success(errorMessages);
            }
          }
        }
      );
  }

  isFormValid(): boolean {
    this.submitted = true;
    this.formUtilsService.MarkFormFieldsTouched(this.userProfileForm);
    return !this.userProfileForm.invalid;
  }

  getFormData() {
    this.submitted = true;

    if (this.userProfileForm.invalid) {
      return null;
    }

    let formData = new FormData();
    const form = this.userProfileForm.value;

    form.phoneNumber = form.phoneNumberControl?.internationalNumber.replace(form.phoneNumberControl?.dialCode , '').trim();
    form.phoneNumber2 = this.isNullOrUndefined(form.phoneNumber2Control?.internationalNumber.replace(form.phoneNumber2Control?.dialCode , '').trim());
    form.contactNumber1 = this.isNullOrUndefined(form.contactNumber1Control?.internationalNumber.replace(form.contactNumber1Control?.dialCode , '').trim());
    form.contactNumber2 = this.isNullOrUndefined(form.contactNumber2Control?.internationalNumber.replace(form.contactNumber2Control?.dialCode , '').trim());

    form.phoneNumberCountryCode = form.phoneNumberControl?.dialCode;
    form.phoneNumber2CountryCode = form.phoneNumber2Control?.dialCode;
    form.contactNumber1CountryCode = form.contactNumber1Control?.dialCode;
    form.contactNumber2CountryCode = form.contactNumber2Control?.dialCode;

    for (var key in form) {
      formData.append(key, form[key] === null ? '' : form[key]);
    }
    if (this.file) {
      formData.append('logoFile', this.file);
    }
    if (this.headerFile) {
      formData.append('headerFile', this.headerFile);
    }
    return formData;
  }

  public isChangePasswordEvent(): void {
    let isPasswordChangedVal =
      this.userProfileForm.get('isPasswordChanged').value;
    if (isPasswordChangedVal) {
      this.userProfileForm.get('password').enable();
      this.userProfileForm.get('confirmPassword').enable();

      return;
    }

    this.userProfileForm.get('password').disable();
    this.userProfileForm.get('confirmPassword').disable();

    return;
  }
}
